export const fmanReportRedirectBasedOnUseCase = (navigate,useCase) => {
//   const useCase = localStorage.getItem("useCase");

  switch (useCase) {
    case "Procurement":
      navigate("/fmnmis");
      break;

    case "Seed Production":
      navigate("/SeedMIS");
      break;

    case "Agri Promoter":
      navigate("/agrimis");
      break;

    case "Research Program":
      navigate("/researchProgramMIS");
      break;

    default:
      navigate("/fmnmis");
      break;
  }
};

